var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"BannerDialog pa-3",class:{is_open: _vm.open}},[_vm._t("default"),_vm._t("action")],2)}
var staticRenderFns = []

export { render, staticRenderFns }